var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 40.968,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 5.121 40.541 C 2.528 40.541 0.427 40.541 0.427 40.541 L 0.427 0.427 C 0.427 0.427 2.528 0.427 5.121 0.427 L 54.624 0.427 C 57.216 0.427 59.318 0.427 59.318 0.427 L 59.318 40.541 C 59.318 40.541 57.216 40.541 54.624 40.541 Z",
    fill: "rgb(255,255,255)",
    strokeWidth: 0.8535483870967742,
    stroke: "rgb(217,217,217)",
    strokeMiterlimit: 3.225806451612903,
    strokeDasharray: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 30.299 29.287 C 28.265 31.042 25.626 32.102 22.744 32.102 C 16.31 32.102 11.095 26.826 11.095 20.318 C 11.095 13.811 16.31 8.535 22.744 8.535 C 25.627 8.535 28.265 9.595 30.299 11.35 C 32.333 9.595 34.972 8.535 37.855 8.535 C 44.288 8.535 49.503 13.811 49.503 20.318 C 49.503 26.826 44.288 32.102 37.855 32.102 C 34.972 32.102 32.333 31.042 30.299 29.287 Z",
    fill: "rgb(237,0,6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 30.299 29.287 C 32.804 27.125 34.392 23.909 34.392 20.318 C 34.392 16.727 32.804 13.511 30.299 11.35 C 32.333 9.595 34.972 8.535 37.855 8.535 C 44.288 8.535 49.503 13.811 49.503 20.318 C 49.503 26.826 44.288 32.102 37.855 32.102 C 34.972 32.102 32.333 31.042 30.299 29.287 Z",
    fill: "rgb(249,160,0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 30.299 29.287 C 32.804 27.125 34.392 23.909 34.392 20.318 C 34.392 16.727 32.804 13.511 30.299 11.35 C 27.795 13.511 26.206 16.727 26.206 20.318 C 26.206 23.909 27.795 27.125 30.299 29.287 Z",
    fill: "rgb(255,94,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMc);
export default __webpack_public_path__ + "static/media/mc.a43dc8ad.svg";
export { ForwardRef as ReactComponent };